<template>
    <q-dialog ref="dialog" @hide="onDialogHide" persistent>
        <q-card class="q-dialog-plugin" style="width: 30vw; max-width: 90vw;">
            <q-toolbar class="bg-primary text-white">
                <q-toolbar-title>{{ caption }}</q-toolbar-title>
                <q-btn flat round dense icon="close" v-close-popup></q-btn>
            </q-toolbar>

            <q-form ref="modelForm">
                <q-card-section v-if="model.MFAEnabled === false">
                    <div class="column items-center">
                        <div class="col">
                            <p>Scan this image in your passcode app</p>
                        </div>
                        <div class="col">
                            <QRCode componentTitle = "QRCodeSource" :dataSource ="qrCodeUrl"></QRCode>
                        </div>
                    </div>
                </q-card-section>
                <q-card-section>
                    <div class="flex column wrap">
                        <div class="col-12">
                            <q-input v-model="model.ConfirmationCode" type="text"
                                     label="Confirmation code"
                                     :rules="[]"
                                     :error="fieldHasError('ConfirmationCode')"
                                     :error-message="fieldErrorMessage('ConfirmationCode')"
                                     dense>
                            </q-input>
                        </div>
                    </div>
                </q-card-section>

                <q-card-actions align="right" class="bg-grey-2">
                    <q-btn color="primary" :label="actionLabel" @click="onOkClick"></q-btn>
                    <q-btn color="white" text-color="black" label="Cancel" @click="onCancelClick"></q-btn>
                </q-card-actions>
            </q-form>
            <q-inner-loading :showing="loading">
                <q-spinner-gears size="50px" color="primary"></q-spinner-gears>
            </q-inner-loading>
        </q-card>
    </q-dialog>
</template>

<style>
</style>

<script>
    export { default } from './mfasettingseditmodel-dialog-screen.js'
</script>